
import { motion } from "framer-motion";
import { brandColors as colors } from "@/lib/palette";

export default function StitchDots({ className = "" }: { className?: string }) {
  const stitches = [
    { x: 10, y: 15, r: 3, fill: colors.lavender },
    { x: 85, y: 8, r: 2.5, fill: colors.tan },
    { x: 45, y: 75, r: 4, fill: colors.sage },
    { x: 70, y: 25, r: 2.5, fill: colors.berryPink },
    { x: 25, y: 55, r: 3, fill: colors.denimBlue },
    { x: 90, y: 65, r: 2.5, fill: colors.lavender },
    { x: 55, y: 12, r: 2.5, fill: colors.tan },
    { x: 15, y: 80, r: 3, fill: colors.berryPink },
  ];
  return (
    <svg
      className={`absolute inset-0 w-full h-full pointer-events-none ${className}`}
      viewBox="0 0 100 100"
    >
      {stitches.map((d, i) => (
        <motion.circle
          key={i}
          cx={d.x}
          cy={d.y}
          r={d.r}
          fill={d.fill}
          opacity={0.2}
          initial={{ scale: 0 }}
          animate={{ scale: [0, 1.2, 1] }}
          transition={{ duration: 0.6, delay: 0.3 + i * 0.08 }}
        />
      ))}
    </svg>
  );
}
